<template>
  <div class="indexMapListRed" style="margin-top:-33px;">
      <transition v-if="isMobile&&goto100special==false">
         <img v-show="startShow" :src="require('./img/fourstart.jpg')" alt="" style="width:100%;height:calc(100% - 80px);position:absolute;left:0px;top:79px;z-index:9999999999;margin-top:-33px">
      </transition>

      <transition v-if="!isMobile&&goto100special==false">
         <img v-show="startShow" :src="require('./img/fourstartpc.jpg')" alt="" style="min-width:100%;min-height:calc(100% - 80px);position:absolute;left:0px;top:79px;z-index:9999999999;margin-top:-33px">
      </transition>
     
      <img v-if="btnFlag" style="position:absolute;right:10px;top:90px;height:40px;width:40px;z-index:999999999;" id="go-top" :src="require('./img/top.png')" @click="backTop">

      <!-- 红色龙江弹窗 -->
      <div v-if="popupVisibleLongjiang" class="leaflet-popup  leaflet-zoom-animated" style="opacity: 1;top: 88px;left: 7px;z-index:999999;width:calc(100% - 14px);height:370px;margin-top:-33px">
        <div class="leaflet-popup-content-wrapper">
          <div class="leaflet-popup-content">
              <div style="height:10px;"></div>
              <mt-search v-model="searchLongjiangValue" placeholder="搜索">
              </mt-search>
              <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10" infinite-scroll-immediate-check="false">
                  <div v-for="item in longjiangPlaces" style="text-align:center;margin-bottom:15px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;">
                    <p @click="locationLongjiang(item)" style="margin-bottom:0px;height:35px;background-color:white;padding-left:10px;"><span style="line-height:35px;font-weight:bold;color:red;font-size:16px;">{{ item.placename }}</span></p>
                    <img class="abc" @click="goVR(item)" :src="item.imgurl" alt="" style="width:100%;" v-bind:style="{ height: heightSize + 'px' }">
                  </div>
                </ul>
          </div>   
        </div>

        <!-- <div class="leaflet-popup-tip-container">
          <div class="leaflet-popup-tip"></div>
        </div> -->

        <a class="leaflet-popup-close-button" href="#course" @click="showListLongjiang">
          ×
        </a>
      </div>


      <!-- 红色中国弹窗 -->
      <div v-if="popupVisibleChina" class="leaflet-popup  leaflet-zoom-animated" style="opacity: 1;top: 88px;left: 7px;z-index:999999;width:calc(100% - 14px);height:370px;margin-top:-33px">
        <div class="leaflet-popup-content-wrapper">

          
          <!-- 首先显示中共党史分类 20210326 -->
          <div class="leaflet-popup-content" v-if="zgdsTypeShow">
              <div style="height:10px;"></div>
              <mt-search v-model="searchLongjiangValue" placeholder="搜索">
              </mt-search>
              <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10" infinite-scroll-immediate-check="false">
                  <div v-for="item in zgdsType" style="text-align:center;margin-bottom:15px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;">
                    <p v-if="item.placename.length<14" @click="locationLongjiang(item)" style="margin-bottom:0px;height:35px;background-color:white;padding-left:10px;"><span style="line-height:35px;font-weight:bold;color:red;font-size:16px;">{{ item.placename }}</span></p>
                    <p v-if="item.placename.length>=14" @click="locationLongjiang(item)" style="margin-bottom:0px;height:70px;background-color:white;padding-left:10px;"><span style="line-height:35px;font-weight:bold;color:red;font-size:16px;">{{ item.placename }}</span></p>
                    <img class="abc" @click="goZgdsType(item)" :src="item.imgurl" alt="" style="width:100%;" v-bind:style="{ height: heightSize + 'px' }">
                  </div>
                </ul>

          </div>

          <div class="leaflet-popup-content" v-if="!zgdsTypeShow">
              <div style="height:10px;"></div>
              <mt-search v-model="searchChinaValue" placeholder="搜索">
              </mt-search>
              <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10" infinite-scroll-immediate-check="false">
                  <div v-for="item in places" style="text-align:center;margin-bottom:15px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;">
                    <p v-if="item.placename.length<20" @click="locationChina(item)" style="margin-bottom:0px;height:35px;background-color:white;padding-left:10px;"><span style="line-height:35px;font-weight:bold;color:red;font-size:16px;">{{ item.placename }}</span></p>
                    <p v-if="item.placename.length>=20&&item.placename.length<36" @click="locationChina(item)" style="margin-bottom:0px;height:70px;background-color:white;padding-left:10px;"><span style="line-height:35px;font-weight:bold;color:red;font-size:16px;">{{ item.placename }}</span></p>
                    <p v-if="item.placename.length>=36" @click="locationChina(item)" style="margin-bottom:0px;height:105px;background-color:white;padding-left:10px;"><span style="line-height:35px;font-weight:bold;color:red;font-size:16px;">{{ item.placename }}</span></p>
                    <img class="abc" @click="goVR(item)" :src="item.imgurl" alt="" style="width:100%;" v-bind:style="{ height: heightSize + 'px' }">
                  </div>
                </ul>

          </div>

        </div>

        <!-- <div class="leaflet-popup-tip-container">
          <div class="leaflet-popup-tip"></div>
        </div> -->

        <a class="leaflet-popup-close-button" href="#course" @click="showListChina">
          ×
        </a>
      </div>


      <!-- 改革开放史弹窗 -->
      <div v-if="popupVisibleGaige" class="leaflet-popup  leaflet-zoom-animated" style="opacity: 1;top: 88px;left: 7px;z-index:999999;width:calc(100% - 14px);height:370px;margin-top:-33px">
        <div class="leaflet-popup-content-wrapper">
          <div class="leaflet-popup-content">
              <div style="height:10px;"></div>
              <mt-search v-model="searchGaigeValue" placeholder="搜索">
              </mt-search>
              <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10" infinite-scroll-immediate-check="false">
                  <div v-for="item in gaigePlaces" style="text-align:center;margin-bottom:15px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;">
                    <p @click="locationChina(item)" style="margin-bottom:0px;height:35px;background-color:white;padding-left:10px;"><span style="line-height:35px;font-weight:bold;color:red;font-size:16px;">{{ item.placename }}</span></p>
                    <img class="abc" @click="goVR(item)" :src="item.imgurl" alt="" style="width:100%;" v-bind:style="{ height: heightSize + 'px' }">
                  </div>
                </ul>

          </div>
        </div>

        <!-- <div class="leaflet-popup-tip-container">
          <div class="leaflet-popup-tip"></div>
        </div> -->

        <a class="leaflet-popup-close-button" href="#course" @click="showListGaige">
          ×
        </a>
      </div>


      <!-- 社会主义史弹窗 -->
      <div v-if="popupVisibleShzy" class="leaflet-popup  leaflet-zoom-animated" style="opacity: 1;top: 88px;left: 7px;z-index:999999;width:calc(100% - 14px);height:370px;margin-top:-33px">
        <div class="leaflet-popup-content-wrapper">
          <div class="leaflet-popup-content">
              <div style="height:10px;"></div>
              <mt-search v-model="searchShzyValue" placeholder="搜索">
              </mt-search>
              <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10" infinite-scroll-immediate-check="false">
                  <div v-for="item in shzyPlaces" style="text-align:center;margin-bottom:15px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;">
                    <p @click="locationChina(item)" style="margin-bottom:0px;height:35px;background-color:white;padding-left:10px;"><span style="line-height:35px;font-weight:bold;color:red;font-size:16px;">{{ item.placename }}</span></p>
                    <img class="abc" @click="goVR(item)" :src="item.imgurl" alt="" style="width:100%;" v-bind:style="{ height: heightSize + 'px' }">
                  </div>
                </ul>

          </div>
        </div>

        <!-- <div class="leaflet-popup-tip-container">
          <div class="leaflet-popup-tip"></div>
        </div> -->

        <a class="leaflet-popup-close-button" href="#course" @click="showListShzy">
          ×
        </a>
      </div>
        <mt-navbar v-model="selected" style="margin-bottom:3px;">
        <mt-tab-item id="2" style="color:color:rgb(68, 85, 102);font-weight:bold;">中共党史</mt-tab-item>
        <mt-tab-item id="1" style="color:color:rgb(68, 85, 102);font-weight:bold;">新中国史</mt-tab-item>
        <mt-tab-item id="3" style="color:color:rgb(68, 85, 102);font-weight:bold;">改革开放史</mt-tab-item>
        <mt-tab-item id="4" style="color:color:rgb(68, 85, 102);font-weight:bold;">社会主义史</mt-tab-item>
      </mt-navbar>

      <!-- <mt-navbar v-model="selected" style="margin-bottom:3px;">
        <mt-tab-item id="2" style="color:rgb(255, 255, 255);font-weight:bold;background-color:rgba(255, 0, 0, 0.35)">中共党史</mt-tab-item>
        <mt-tab-item id="1" style="color:rgb(255, 255, 255);font-weight:bold;background-color:rgba(255, 0, 0, 0.35)">新中国史</mt-tab-item>
        <mt-tab-item id="3" style="color:rgb(255, 255, 255);font-weight:bold;background-color:rgba(255, 0, 0, 0.35)">改革开放史</mt-tab-item>
        <mt-tab-item id="4" style="color:rgb(255, 255, 255);font-weight:bold;background-color:rgba(255, 0, 0, 0.35)">社会主义史</mt-tab-item>
      </mt-navbar> -->

      <!-- old code -->
      <!-- <div style="height:10px;"></div>
                <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10" >
                  <div @click="goVR(item)" v-for="item in places" style="margin-left:9px;margin-right:9px;margin-bottom:15px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;">
                    <p style="margin-bottom:0px;height:35px;background-color:white;padding-left:10px;"><span style="line-height:35px;font-weight:bold;color:red;font-size:16px;">{{ item.placename }}</span></p>
                    <img :src="item.imgurl" alt="" style="width:100%;" v-bind:style="{ height: heightSize + 'px' }">
                  </div>
                </ul> -->

      <mt-tab-container v-model="selected">
        <mt-tab-container-item id="1">
         
          <div id="map-container-longjiang" style="width:100%;position:relative;"> 
            <div id="mapRedLongjiang" style="width:100%;height:100%;">
              <!-- 列表 -->
              <div class="leaflet-top leaflet-right">
                <div class="leaflet-control" style="background: #fff;border-radius:5px;border:2px solid rgba(0,0,0,0.2);padding:6px;color:rgb(68, 85, 102);font-weight:bold;" @click="showListLongjiang">列表模式</div>
              </div>
            </div>
          </div>

        </mt-tab-container-item>
        <mt-tab-container-item id="2">
         

            <div id="map-container-china" style="width:100%;">
            <div id="mapRedChina" style="width:100%;height:100%;z-index:999998;">
              
              <div class="leaflet-top leaflet-right">
                <div class="leaflet-control" style="background: #fff;border-radius:5px;border:2px solid rgba(0,0,0,0.2);padding:6px;color:rgb(68, 85, 102);font-weight:bold;" @click="showListChina">列表模式</div>
              </div>
            </div>
          </div>


        </mt-tab-container-item>

        <mt-tab-container-item id="3">

          <div id="map-container-gaige" style="width:100%;">
            <div id="mapRedGaige" style="width:100%;height:100%;z-index:999998;">
               <!-- 列表 -->
              <div class="leaflet-top leaflet-right">
                <div class="leaflet-control" style="background: #fff;border-radius:5px;border:2px solid rgba(0,0,0,0.2);padding:6px;color:rgb(68, 85, 102);font-weight:bold;" @click="showListGaige">列表模式</div>
              </div>
            </div>
          </div>

        </mt-tab-container-item>

        <mt-tab-container-item id="4">

          <div id="map-container-shzy" style="width:100%;">
            <div id="mapRedShzy" style="width:100%;height:100%;z-index:999998;">
               <!-- 列表 -->
              <div class="leaflet-top leaflet-right">
                <div class="leaflet-control" style="background: #fff;border-radius:5px;border:2px solid rgba(0,0,0,0.2);padding:6px;color:rgb(68, 85, 102);font-weight:bold;" @click="showListShzy">列表模式</div>
              </div>
            </div>
          </div>

        </mt-tab-container-item>

      </mt-tab-container>
  </div>
</template>

<script>
import openUrl from "./../utils/openUrl";
// import IndexApi from "../api/learingInd.js";
import cfg from "./../utils/config";
import Vue from "vue";
import L from "leaflet";
import axios from "axios";
import Addr from "./../utils/getAPI";

export default {
  name: "indexMapListRed",
  data() {
    return {
      goto100special:false,
      startShow:true,
      isMobile:true,
      searchLongjiangValue:"",
      searchChinaValue:"",
      searchGaigeValue:"",
      searchShzyValue:"",
      btnFlag: false, //回到顶部
      mapLongjiang: null,
      mapChina: null,
      popupVisibleLongjiang: false,
      popupVisibleChina: false,
      popupVisibleGaige: false,
      popupVisibleShzy: false,
      heightSize: 120,
      allShzyPlaces:[],
      shzyPlaces:[],
      allGaigePlaces:[],
      gaigePlaces:[],
      //首先显示中共党史分类 20210326
      zgdsTypeShow:true,
      zgdsOldType:[
        {
            "imgurl": Addr.getCdnAddr()+"qiniu/four/196special/196special.jpg",
            "subtype": 4,
            "placename": "十九届六中全会学习专题",
        },
        {
            "imgurl": Addr.getCdnAddr()+"qiniu/four/100special/100special.jpg",
            "subtype": 3,
            "placename": "习近平总书记在庆祝中国共产党成立100周年大会上的重要讲话学习辅导",
        },
        {
            "imgurl": Addr.getCdnAddr()+"qiniu/four/dsxx.png",
            "subtype": 0,
            "placename": "党史学习",
            "hasChildren":true,
            "children":[
              {
                "imgurl": Addr.getCdnAddr()+"qiniu/four/xjpjh.jpg",
                "subtype": -1,
                "placename": "习近平讲话",
              },
              {
                "imgurl": Addr.getCdnAddr()+"qiniu/four/dzs.png",
                "subtype": 0,
                "placename": "电子书",
              }
            ]
        },
        {
            "imgurl": Addr.getCdnAddr()+"qiniu/four/hsjy.png",
            "subtype": 1,
            "placename": "红色记忆",
        },
        {
            "imgurl": Addr.getCdnAddr()+"qiniu/four/yxzg.png",
            "subtype": 2,
            "placename": "英雄赞歌",
        }
      ],
      zgdsType:[
         {
            "imgurl": Addr.getCdnAddr()+"qiniu/four/196special/196special.jpg",
            "subtype": 4,
            "placename": "十九届六中全会学习专题",
        },
        {
            "imgurl": Addr.getCdnAddr()+"qiniu/four/100special/100special.jpg",
            "subtype": 3,
            "placename": "习近平总书记在庆祝中国共产党成立100周年大会上的重要讲话学习辅导",
        },
        {
            "imgurl": Addr.getCdnAddr()+"qiniu/four/dsxx.png",
            "subtype": 0,
            "placename": "党史学习",
            "hasChildren":true,
            "children":[
              {
                "imgurl": Addr.getCdnAddr()+"qiniu/four/xjpjh.jpg",
                "subtype": -1,
                "placename": "习近平讲话",
              },
              {
                "imgurl": Addr.getCdnAddr()+"qiniu/four/dzs.png",
                "subtype": 0,
                "placename": "电子书",
              }
            ]
        },
        {
            "imgurl": Addr.getCdnAddr()+"qiniu/four/hsjy.png",
            "subtype": 1,
            "placename": "红色记忆",
        },
        {
            "imgurl": Addr.getCdnAddr()+"qiniu/four/yxzg.png",
            "subtype": 2,
            "placename": "英雄赞歌",
        }
      ],
      allLongjiangPlaces:[],
      longjiangPlaces: [
        // {
        //   id: 0,
        //   imgurl: require("./img/wangjinxi.png"),
        //   lat: 46.60792075653775,
        //   lon: 124.8801291547716,
        //   level: 0,
        //   placename: "铁人纪念馆",
        //   yunurl: "https://720yun.com/t/55725qfuwln?scene_id=929007"
        // },
        // {
        //   id: 0,
        //   imgurl: require("./img/daqing.png"),
        //   lat: 46.58162907799555,
        //   lon: 125.14610085636379,
        //   level: 1,
        //   placename: "大庆博物馆",
        //   yunurl: "https://720yun.com/t/665juptvsk7?scene_id=22463034"
        // },
        // {
        //   id: 0,
        //   imgurl: require("./img/kanglian.png"),
        //   lat: 45.76428598255321,
        //   lon: 126.6367437131703,
        //   level: 2,
        //   placename: "东北抗联博物馆",
        //   yunurl: "https://720yun.com/t/9f128wfgaui?scene_id=154232"
        // },
        // {
        //   id: 0,
        //   imgurl: require("./img/beidahuang.png"),
        //   lat: 45.73242071563545,
        //   lon: 126.68984063901009,
        //   level: 3,
        //   placename: "北大荒博物馆",
        //   yunurl: "https://720yun.com/t/fa122ar69uw?scene_id=737539"
        // },
        // {
        //   id: 0,
        //   imgurl: require("./img/0.jpg"),
        //   lat: 45.77525,
        //   lon: 126.65078,
        //   level: 4,
        //   placename: "伍连德纪念馆",
        //   yunurl: "https://720yun.com/t/37fjvOevOf5?scene_id=21807637"
        // },
        // {
        //   id: 1,
        //   imgurl: require("./img/1.jpg"),
        //   lat: 45.75954,
        //   lon: 126.64248,
        //   level: 5,
        //   placename: "革命领袖视察黑龙江纪念馆",
        //   yunurl: "https://720yun.com/t/bcdjursOzv3?scene_id=21716447"
        // },
        // {
        //   id: 2,
        //   imgurl: require("./img/2.jpg"),
        //   lat: 45.74466,
        //   lon: 126.69622,
        //   level: 6,
        //   placename: "黑龙江省地质博物馆",
        //   yunurl: "https://720yun.com/t/a182fmp89tf?scene_id=942186"
        // },
        // {
        //   id: 3,
        //   imgurl: require("./img/3.jpg"),
        //   lat: 45.75758,
        //   lon: 126.64089,
        //   level: 7,
        //   placename: "黑龙江省博物馆",
        //   yunurl: "https://720yun.com/t/2e4je04aum0?scene_id=16418570"
        // }
      ],
      allPlaces:[],
      places: [
        // {
        //   placename: "井冈山",
        //   imgurl: require("./img/jinggangshan.png"),
        //   yunurl: "http://720yun.com/t/b17jkrwaOy9?pano_id=3855779"
        // },
        // {
        //   placename: "延安",
        //   imgurl: require("./img/yanan.png"),
        //   yunurl: "http://720yun.com/t/27bjkrha5v8?pano_id=3401231"
        // },
        // {
        //   placename: "西柏坡",
        //   imgurl: require("./img/xibaipo.png"),
        //   yunurl: "http://720yun.com/t/ee2jO5euzu1?pano_id=2124437"
        // }
      ],
      selected: "2"
      // reds: [
      //   {
      //     name: "井冈山",
      //     longitude: 114.28757429122926,
      //     latitude: 26.7394783802926,
      //     link: "http://720yun.com/t/b17jkrwaOy9?pano_id=3855779"
      //     // img: "school5"
      //   },
      //   {
      //     name: "延安",
      //     longitude: 109.48414027690889,
      //     latitude: 36.58258998246001,
      //     link: "http://720yun.com/t/27bjkrha5v8?pano_id=3401231"
      //     // img: "school3"
      //   },
      //   {
      //     name: "西柏坡",
      //     longitude: 113.93864035606386,
      //     latitude: 38.34030979622722,
      //     link: "http://720yun.com/t/ee2jO5euzu1?pano_id=2124437"
      //     // img: "school6"
      //   },
      //   {
      //     name: "全景思政第一集",
      //     longitude: 113.26035261154176,
      //     latitude: 23.130257185291036,
      //     link: "http://www.utovr.com/video/281008559321.html"
      //     // img: "school2"
      //   },
      //   {
      //     name: "全景思政第二集",
      //     longitude: 114.05641078948976,
      //     latitude: 22.543000965921863,
      //     link: "http://www.utovr.com/video/291108523648.html"
      //     // img: "school1"
      //   },
      //   {
      //     name: "全景思政片花",
      //     longitude: 113.627986907959,
      //     latitude: 22.811630707692423,
      //     link: "https://720yun.com/v/fe6zb0rs5ir"
      //     // img: "school7"
      //   }
      // ]
    };
  },
  methods: {
  
    //是否是开屏按钮跳转过来的
    checkGoto100Special(){
      if(localStorage.getItem("goto100special")!=null&&localStorage.getItem("goto100special")=="yes"){
        this.goto100special=true;
        localStorage.removeItem("goto100special");
        this.showListChina();
      }
    },
    //vue 回到顶部 https://blog.csdn.net/qq_36070288/article/details/84765139
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop() {
      let that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 60) {
        // console.log("scrollTop is"+that.scrollTop);
        //动态改变回到顶部按钮的位置
        if (document.getElementById("go-top")) {
          document.getElementById("go-top").style.top =
            that.scrollTop + 350 + "px";
        }
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    },
    locationLongjiang(item) {
      this.mapLongjiang.setView([item.lat, item.lon], 14);
      this.showListLongjiang();
    },
    locationChina(item) {
      this.mapChina.setView([item.lat, item.lon], 9);
      this.showListChina();
    },
    showListChina() {
      console.log("showListChina");
      this.popupVisibleChina = !this.popupVisibleChina;
      if(this.popupVisibleChina==false){
        this.zgdsTypeShow=false;
        //20210406 fix bug
        this.zgdsType=this.zgdsOldType;
        //fix bug
        this.places=this.allPlaces;
      }
      if(this.popupVisibleChina==true){
        this.zgdsTypeShow=true;
      }
    },
    showListLongjiang() {
      console.log("showListLongjiang");
      this.popupVisibleLongjiang = !this.popupVisibleLongjiang;
    },
    showListGaige() {
      console.log("showListGaige");
      this.popupVisibleGaige = !this.popupVisibleGaige;
    },
    showListShzy() {
      console.log("showListShzy");
      this.popupVisibleShzy = !this.popupVisibleShzy;
    },
    setSize() {
      //1 index-map-list
      if (document.getElementById("map-container-longjiang")) {
        //设置地图高度
        document.getElementById("map-container-longjiang").style.height =
          window.innerHeight - 85 + "px"; //167
      }
      if (document.getElementById("map-container-china")) {
        //设置地图高度
        document.getElementById("map-container-china").style.height =
          window.innerHeight - 85 + "px"; //167
      }
      if (document.getElementById("map-container-gaige")) {
        //设置地图高度
        document.getElementById("map-container-gaige").style.height =
          window.innerHeight - 85 + "px"; //167
      }
      if (document.getElementById("map-container-shzy")) {
        //设置地图高度
        document.getElementById("map-container-shzy").style.height =
          window.innerHeight - 85 + "px"; //167
      }
        //新增十九届六中全会内容
         if (document.getElementById("map-container-shijiuliu")) {
        //设置地图高度
        document.getElementById("map-container-shijiuliu").style.height =
          window.innerHeight - 118 + "px"; //167
      }

    },
    goZgdsType(item){
      let subtype=item.subtype;
      let hasChildren=item.hasChildren;

      if(hasChildren){
        // this.$set(this.$data,"zgdsType",item.children);
        this.zgdsType=item.children;
        //重新渲染
        this.$forceUpdate();
      }else{
        console.log("subtype is:",subtype);
        this.zgdsTypeShow=false;
        //20210406 fix bug
        this.zgdsType=this.zgdsOldType;
        //fix bug
        this.allPlaces=this.places;
        this.places=this.places.filter(it=>it.subtype==subtype);
        console.log('过滤后的this.places.', this.places)
      }
      
    },
    goVR(place) {
      //window.location.href = place.yunurl;
      openUrl.openInExplorer(place.yunurl);
    },
    loadMore() {
      this.loading = true;
      setTimeout(() => {
        // let last = this.list[this.list.length - 1];
        // for (let i = 1; i <= 10; i++) {
        //   this.list.push(last + i);
        // }
        this.loading = false;
      }, 2500);
    },
    mapInit() {
      //leaflet 自定义图标 https://blog.csdn.net/funkstill/article/details/85773103
      //自定义图标 党旗
      //定义icon类以创建一组图标使用相同属性的图标
      let LeafIcon = L.Icon.extend({
        options: {
          // shadowUrl: "./image/leaf-shadow.png",
          iconSize: [30, 30],
          // shadowSize: [50, 64],
          // iconAnchor: [0, 0],
          // shadowAnchor: [4, 62],
          popupAnchor: [0, -10]
        }
      });
      let redIcon = new LeafIcon({ iconUrl: require("./img/dang.png") });

      this.mapLongjiang = L.map("mapRedLongjiang", {
        attributionControl:false,
        center: [37.71859032558816, 105.70358276367189],
        zoom: 4
      });
      // 影像
      L.tileLayer(
        "http://t{s}.tianditu.com/img_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=img&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b10eec7dfb398dbea06b2db14bf72fbc",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
        }
      ).addTo(this.mapLongjiang);
      // 地名标注
      L.tileLayer(
        "http://t{s}.tianditu.com/cia_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=cia&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b10eec7dfb398dbea06b2db14bf72fbc",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
        }
      ).addTo(this.mapLongjiang);
      // 边界
      L.tileLayer(
        "http://t{s}.tianditu.com/ibo_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=ibo&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b10eec7dfb398dbea06b2db14bf72fbc",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
        }
      ).addTo(this.mapLongjiang);
      // //设置地图高度
      // document.getElementById("map-container").style.height =
      //   window.innerHeight - 118 + "px";
      this.mapChina = L.map("mapRedChina", {
        attributionControl:false,
        center: [37.71859032558816, 105.70358276367189],
        zoom: 4
      });
      // 影像
      L.tileLayer(
        "http://t{s}.tianditu.com/img_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=img&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b10eec7dfb398dbea06b2db14bf72fbc",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
        }
      ).addTo(this.mapChina);
      // 地名标注
      L.tileLayer(
        "http://t{s}.tianditu.com/cia_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=cia&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b10eec7dfb398dbea06b2db14bf72fbc",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
        }
      ).addTo(this.mapChina);
      // 边界
      L.tileLayer(
        "http://t{s}.tianditu.com/ibo_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=ibo&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b10eec7dfb398dbea06b2db14bf72fbc",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
        }
      ).addTo(this.mapChina);


      this.mapGaige = L.map("mapRedGaige", {
        attributionControl:false,
        center: [37.71859032558816, 105.70358276367189],
        zoom: 4
      });
      // 影像
      L.tileLayer(
        "http://t{s}.tianditu.com/img_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=img&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b10eec7dfb398dbea06b2db14bf72fbc",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
        }
      ).addTo(this.mapGaige);
      // 地名标注
      L.tileLayer(
        "http://t{s}.tianditu.com/cia_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=cia&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b10eec7dfb398dbea06b2db14bf72fbc",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
        }
      ).addTo(this.mapGaige);
      // 边界
      L.tileLayer(
        "http://t{s}.tianditu.com/ibo_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=ibo&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b10eec7dfb398dbea06b2db14bf72fbc",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
        }
      ).addTo(this.mapGaige);


      this.mapShzy = L.map("mapRedShzy", {
        attributionControl:false,
        center: [49.599, 10.943],
        zoom: 4
      });
      // 影像
      L.tileLayer(
        "http://t{s}.tianditu.com/img_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=img&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b10eec7dfb398dbea06b2db14bf72fbc",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
        }
      ).addTo(this.mapShzy);
      // 地名标注
      L.tileLayer(
        "http://t{s}.tianditu.com/cia_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=cia&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b10eec7dfb398dbea06b2db14bf72fbc",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
        }
      ).addTo(this.mapShzy);
      // 边界
      L.tileLayer(
        "http://t{s}.tianditu.com/ibo_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=ibo&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b10eec7dfb398dbea06b2db14bf72fbc",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
        }
      ).addTo(this.mapShzy);


      let _self = this;

      console.log(_self.places);

      _self.places.forEach(item => {
        var linkComponent = Vue.extend({
          // template: '<a @click="goArea('+item.name+','+item.img+')">' + item.name + '</a>',
          template: '<a @click="goArea()">' + item.placename + "</a>",
          methods: {
            goArea() {
              // console.log("got it");
              // _self.$router.push({
              //     path: "/area",
              //     query: {
              //         name: item.name,
              //         img: item.img
              //     }
              // });

              //window.location.href = item.yunurl;
              openUrl.openInExplorer(item.yunurl);
              //localStorage.setItem('backPlace','/mine');

              //mui.openWindow(getAliYunAddr() + "detail.html?link=" + item.link);
            }
          }
        });
        var component = new linkComponent().$mount();

        var name = item.name;
        var marker = L.marker([item.lat, item.lon], { icon: redIcon })
          .addTo(this.mapChina)
          .bindPopup(
            component.$el
            // '<a>' + item.name + '</a>'

            // '<a href="' +
            // item.link +
            // "?name=" +
            // encodeURI(item.name) +
            // "&img=" +
            // item.img +
            // '">' +
            // item.name +
            // "></a>"
          );
      });

      //红色龙江的标注
      _self.longjiangPlaces.forEach(item => {
        var linkComponent = Vue.extend({
          // template: '<a @click="goArea('+item.name+','+item.img+')">' + item.name + '</a>',
          template: '<a @click="goArea()">' + item.placename + "</a>",
          methods: {
            goArea() {
              // console.log("got it");
              // _self.$router.push({
              //     path: "/area",
              //     query: {
              //         name: item.name,
              //         img: item.img
              //     }
              // });

              //window.location.href = item.yunurl;
              openUrl.openInExplorer(item.yunurl);
              //localStorage.setItem('backPlace','/mine');

              //mui.openWindow(getAliYunAddr() + "detail.html?link=" + item.link);
            }
          }
        });
        var component = new linkComponent().$mount();

        var name = item.name;
        var marker = L.marker([item.lat, item.lon], { icon: redIcon })
          .addTo(this.mapLongjiang)
          .bindPopup(
            component.$el
            // '<a>' + item.name + '</a>'

            // '<a href="' +
            // item.link +
            // "?name=" +
            // encodeURI(item.name) +
            // "&img=" +
            // item.img +
            // '">' +
            // item.name +
            // "></a>"
          );
      });

      //红色龙江的标注
      _self.longjiangPlaces.forEach(item => {
        var linkComponent = Vue.extend({
          // template: '<a @click="goArea('+item.name+','+item.img+')">' + item.name + '</a>',
          template: '<a @click="goArea()">' + item.placename + "</a>",
          methods: {
            goArea() {
              // console.log("got it");
              // _self.$router.push({
              //     path: "/area",
              //     query: {
              //         name: item.name,
              //         img: item.img
              //     }
              // });

              //window.location.href = item.yunurl;
              openUrl.openInExplorer(item.yunurl);
              //localStorage.setItem('backPlace','/mine');

              //mui.openWindow(getAliYunAddr() + "detail.html?link=" + item.link);
            }
          }
        });
        var component = new linkComponent().$mount();

        var name = item.name;
        var marker = L.marker([item.lat, item.lon], { icon: redIcon })
          .addTo(this.mapLongjiang)
          .bindPopup(
            component.$el
            // '<a>' + item.name + '</a>'

            // '<a href="' +
            // item.link +
            // "?name=" +
            // encodeURI(item.name) +
            // "&img=" +
            // item.img +
            // '">' +
            // item.name +
            // "></a>"
          );
      });


      //改革开放史的标注
      _self.gaigePlaces.forEach(item => {
        var linkComponent = Vue.extend({
          // template: '<a @click="goArea('+item.name+','+item.img+')">' + item.name + '</a>',
          template: '<a @click="goArea()">' + item.placename + "</a>",
          methods: {
            goArea() {
              // console.log("got it");
              // _self.$router.push({
              //     path: "/area",
              //     query: {
              //         name: item.name,
              //         img: item.img
              //     }
              // });

              //window.location.href = item.yunurl;
              openUrl.openInExplorer(item.yunurl);
              //localStorage.setItem('backPlace','/mine');

              //mui.openWindow(getAliYunAddr() + "detail.html?link=" + item.link);
            }
          }
        });
        var component = new linkComponent().$mount();

        var name = item.name;
        var marker = L.marker([item.lat, item.lon], { icon: redIcon })
          .addTo(this.mapGaige)
          .bindPopup(
            component.$el
            // '<a>' + item.name + '</a>'

            // '<a href="' +
            // item.link +
            // "?name=" +
            // encodeURI(item.name) +
            // "&img=" +
            // item.img +
            // '">' +
            // item.name +
            // "></a>"
          );
      });

       //社会主义史的标注
      _self.shzyPlaces.forEach(item => {
        var linkComponent = Vue.extend({
          // template: '<a @click="goArea('+item.name+','+item.img+')">' + item.name + '</a>',
          template: '<a @click="goArea()">' + item.placename + "</a>",
          methods: {
            goArea() {
              // console.log("got it");
              // _self.$router.push({
              //     path: "/area",
              //     query: {
              //         name: item.name,
              //         img: item.img
              //     }
              // });

              //window.location.href = item.yunurl;
              openUrl.openInExplorer(item.yunurl);
              //localStorage.setItem('backPlace','/mine');

              //mui.openWindow(getAliYunAddr() + "detail.html?link=" + item.link);
            }
          }
        });
        var component = new linkComponent().$mount();

        var name = item.name;
        var marker = L.marker([item.lat, item.lon], { icon: redIcon })
          .addTo(this.mapShzy)
          .bindPopup(
            component.$el
            // '<a>' + item.name + '</a>'

            // '<a href="' +
            // item.link +
            // "?name=" +
            // encodeURI(item.name) +
            // "&img=" +
            // item.img +
            // '">' +
            // item.name +
            // "></a>"
          );
      });

      this.mapChina.invalidateSize();
      this.mapLongjiang.invalidateSize();
      this.mapGaige.invalidateSize();
      this.mapShzy.invalidateSize();
    },
    init: function() {
      // IndexApi.red((ret, err) => {
      //   if (err) {
      //     console.log("数据获取失败！");
      //   } else {
      //     this.places = ret.data;
      //   }
      // });

        //初始化请求数据
        console.log('地址是',Addr.getGoNewAPIPrefix() + "red/listRed?pageNum=1&pageRow=1000")
      axios
        .get(Addr.getGoNewAPIPrefix() + "red/listRed?pageNum=1&pageRow=1000")
        .then(res => {
          console.log("res is:",res);
          console.log(res);
          if (res.data.returnCode == 100) {
            this.places=[];
            this.longjiangPlaces=[];
            this.gaigePlaces=[];
            this.shzyPlaces=[];

            res.data.returnData.list.forEach(item => {
              //红色中国-->中共党史
              if(item.type==0){
                this.places.push(item);
      
              }
              //红色龙江-->新中国史
              if(item.type==1){
                this.longjiangPlaces.push(item);
              }
              // 改革开放史
              if(item.type==2){
                this.gaigePlaces.push(item);
              }
              // 社会主义史
              if(item.type==3){
                this.shzyPlaces.push(item);
              }
            });
            //search前备份
            this.allPlaces=this.places;
            //search前备份
            this.allLongjiangPlaces=this.longjiangPlaces;
            //search前备份
            this.allGaigePlaces=this.gaigePlaces;
            //search前备份
            this.allShzyPlaces=this.shzyPlaces;

            this.mapInit();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 首页搜索
    goSeach: function() {
      this.$router.push({ path: "/search/" });
    },
    // 搜索处理
    onblurEvent: function() {
      if (this.searchName === "") {
        this.seachWt = "65px";
      } else {
        this.seachWt = "90%";
      }
    },
    focusEvent: function() {
      this.seachWt = "90%";
    }
  },
  watch: {
    searchLongjiangValue: function(newVal, oldVal) {
      console.log("longjiang change");
      console.log(oldVal);
      console.log(newVal);
      if(newVal==""){
        this.longjiangPlaces=this.allLongjiangPlaces;
      }else{
        this.longjiangPlaces=this.allLongjiangPlaces.filter(item => item.placename.indexOf(newVal)!=-1);
      }
      
    },
    searchChinaValue: function(newVal, oldVal) {
      console.log("china change");
      console.log(oldVal);
      console.log(newVal);
      if(newVal==""){
        this.places=this.allPlaces;
      }else{
        this.places=this.allPlaces.filter(item => item.placename.indexOf(newVal)!=-1);
      }
    },
    searchGaigeValue: function(newVal, oldVal) {
      console.log("gaige change");
      console.log(oldVal);
      console.log(newVal);
      if(newVal==""){
        this.gaigePlaces=this.allGaigePlaces;
      }else{
        this.gaigePlaces=this.allGaigePlaces.filter(item => item.placename.indexOf(newVal)!=-1);
      }
    },
    searchShzyValue: function(newVal, oldVal) {
      console.log("shzy change");
      console.log(oldVal);
      console.log(newVal);
      if(newVal==""){
        this.shzyPlaces=this.allShzyPlaces;
      }else{
        this.shzyPlaces=this.allShzyPlaces.filter(item => item.placename.indexOf(newVal)!=-1);
      }
    },
    selected: function(newVal, oldVal) {
      console.log(newVal);
      if (newVal == 2) {
        this.popupVisibleLongjiang = false;
        this.popupVisibleGaige=false;
        this.popupVisibleShzy=false;
        //leaflet地图在选项卡中不正常显示  http://www.bubuko.com/infodetail-1905601.html
        L.Util.requestAnimFrame(
          this.mapChina.invalidateSize,
          this.mapChina,
          !1,
          this.mapChina._container
        );
      }
      if (newVal == 1) {
        this.popupVisibleChina = false;
        this.popupVisibleGaige=false;
        this.popupVisibleShzy=false;
        //leaflet地图在选项卡中不正常显示  http://www.bubuko.com/infodetail-1905601.html
        L.Util.requestAnimFrame(
          this.mapLongjiang.invalidateSize,
          this.mapLongjiang,
          !1,
          this.mapLongjiang._container
        );
      }
      if (newVal == 3) {
        this.popupVisibleChina = false;
        this.popupVisibleLongjiang=false;
        this.popupVisibleShzy=false;
        //leaflet地图在选项卡中不正常显示  http://www.bubuko.com/infodetail-1905601.html
        L.Util.requestAnimFrame(
          this.mapGaige.invalidateSize,
          this.mapGaige,
          !1,
          this.mapGaige._container
        );
      }
      if (newVal == 4) {
        this.popupVisibleChina = false;
        this.popupVisibleLongjiang=false;
        this.popupVisibleGaige=false;
        //leaflet地图在选项卡中不正常显示  http://www.bubuko.com/infodetail-1905601.html
        L.Util.requestAnimFrame(
          this.mapShzy.invalidateSize,
          this.mapShzy,
          !1,
          this.mapShzy._container
        );
      }
    }
  },
  destroyed() {
    //回到顶部
    window.removeEventListener("scroll", this.scrollToTop);
  },
  mounted: function() {
    //检查是否是开屏按钮跳转过来的
    this.checkGoto100Special();
    let isMobile = {
      Android: function() {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function() {
        return navigator.userAgent.match(/IEMobile/i);
      },
      any: function() {
        return (
          isMobile.Android() ||
          isMobile.BlackBerry() ||
          isMobile.iOS() ||
          isMobile.Opera() ||
          isMobile.Windows()
        );
      }
    };
    this.isMobile=isMobile.any();
     console.log('this.isMobile',this.isMobile)
    //启动图片消失
    setTimeout(()=>{
      this.startShow=false;
    },1000);
    //回到顶部
    window.addEventListener("scroll", this.scrollToTop);

    window.addEventListener("resize", () => {
      this.setSize();
    });

    this.setSize();

    if (window.innerWidth > cfg.widthLimit) {
      this.heightSize = 200;
    }

    this.init();

    // console.log("route is:");
    // console.log(this.$route.fullPath);
    var that = this;
    mui.plusReady(function() {
      // //首页返回键处理
      // //处理逻辑：1秒内，连续两次按返回键，则退出应用；
      var first = null;
      mui.back = function() {
        //首次按键，提示  再按一次退出应用
        if (!first) {
          if (
            that.$route.fullPath == "/index" ||
            that.$route.fullPath == "/list" ||
            that.$route.fullPath == "/course" ||
            that.$route.fullPath == "/my"
          ) {
            first = new Date().getTime(); //记录第一次按下回退键的时间
            mui.toast("再按一次退出应用"); //给出提示
          } else {
            history.go(-1); //回退到上一页面
          }

          setTimeout(function() {
            //1s中后清除
            first = null;
          }, 1000);
        } else {
          if (new Date().getTime() - first < 1000) {
            //如果两次按下的时间小于1s，
            plus.runtime.quit(); //那么就退出app
          }
        }
      };
    });

    // var that = this;
    // (function($) {
    //   // //首页返回键处理
    //   // //处理逻辑：1秒内，连续两次按返回键，则退出应用；
    //   var first = null;
    //   mui.back = function() {
    //     //首次按键，提示  再按一次退出应用
    //     if (!first) {
    //       first = new Date().getTime(); //记录第一次按下回退键的时间
    //       mui.toast("再按一次退出应用"); //给出提示
    //       history.go(-1); //回退到上一页面
    //       setTimeout(function() {
    //         //1s中后清除
    //         first = null;
    //       }, 1000);
    //     } else {
    //       if (new Date().getTime() - first < 1000) {
    //         //如果两次按下的时间小于1s，
    //         plus.runtime.quit(); //那么就退出app
    //       }
    //     }
    //   };
    // })(mui);

    //this.mapInit();
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/baseScss";
@media screen and (min-width: 800px) { 
  .abc {height: 500px!important}  
}

.v-enter,
.v-leave-to{
    opacity: 0;
    transform: translateX(100px);
}
.v-enter-active,
.v-leave-active{
    transition: all 1.2s ease;
}

// .slow-fade-active, .slow-fade-active {
//   transition: opacity .5s;
// }
// .slow-fade, .slow-fade-to /* .fade-leave-active below version 2.1.8 */ {
//   opacity: 0;
// }

// .slow-fade-leave-active {
//   transition: all 1.8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
// }

//
a.leaflet-popup-close-button {
  position: absolute;
  top: 0;
  right: 0;
  padding: 4px 4px 0 0;
  border: none;
  text-align: center;
  width: 18px;
  height: 14px;
  font: 16px/14px Tahoma, Verdana, sans-serif;
  color: #c3c3c3;
  text-decoration: none;
  font-weight: bold;
  background: transparent;
}
//隐藏放大缩小
.leaflet-left {
  display: none;
}

.mint-tab-item.is-selected {
  color: #e70202 !important;
  border-bottom: 2px solid #e70202 !important;
}
.mint-navbar {
  margin-left: 35px;
  width: calc(100% - 35px);
}

.indexHeader {
  height: 200px;
  position: relative;
}
.indexHeader {
  .search {
    position: absolute;
    z-index: 99;
    width: 90%;
    left: 5%;
    top: 10px;
    background: rgba(255, 255, 255, 0.9);
    color: $cl4;
    line-height: 35px;
    input {
      height: 35px;
      width: 65px;
      line-height: 35px;
      background: transparent;
      border: none;
      font-size: 16px;
      padding: 0 1px;
    }
    input:focus {
      outline: medium;
      width: 85%;
    }
    i:before {
      position: relative;
      font-size: 16px;
      top: 1px;
      left: 3px;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/index-map-list-red.vue